export default {
  welcome: "Bienvenido a Mily's Beauty Salon",
  save: "Guardar",
  cancel: "Cancelar",
  stylist: "Estilista",
  close: "Cerrar",
  login: {
    title: "Bienvenido a Mily's Beauty Salon",
    subtitle: "Por favor, inicia sesión para continuar",
    username: "Usuario",
    password: "Contraseña",
    button: "Entrar",
    error: "Usuario o contraseña incorrectos",
    changePassword: "Establece una nueva contraseña",
    changePasswordMsg:
      "Por seguridad, debes cambiar tu contraseña asignada por default.",
    newPassword: "Nueva contraseña",
    newPasswordRules: "Ingresa la nueva contraseña",
    confirmPassword: "Confirmar contraseña",
    confirmPasswordRules: "Las contraseñas no coinciden",
    savePassword: "Guardar nueva contraseña",
    submitChagePasswordError1: "Debes llenar ambos campos",
    submitChagePasswordError2: "Las contraseñas no coinciden",
    submitChagePasswordError3: "La contraseña debe tener al menos 6 caracteres",
    submitChagePasswordSuccess: "Contraseña cambiada exitosamente",
    submitChagePasswordError:
      "Error al cambiar la contraseña, intenta de nuevo",
  },
  sidebar: {
    dashboard: "Tablero",
    users: "Estilistas",
    clients: "Clientes",
    services: "Servicios",
    queue: "Fila Virtual",
    attention: "Procedimientos",
    analytics: "Análisis",
    changePassword: "Cambiar contraseña",
    logout: "Cerrar sesión",
    currentPassword: "Contraseña actual",
    newPassword: "Nueva contraseña",
    confirmNewPassword: "Confirmar nueva contraseña",
    fillAllFields: "Completa todos los campos.",
    passwordMismatch: "Las contraseñas no coinciden.",
    newPasswordLengthError:
      "La nueva contraseña debe tener al menos 6 caracteres.",
    passwordChangedSuccess: "Contraseña cambiada exitosamente.",
    serverError: "Error en el servidor.",
    user: "Usuario",
  },
  dashboard: {
    welcome: "Bienvenido al Salón de Belleza",
    attendedToday: "Atenciones hoy",
    newClientsToday: "Clientes nuevos hoy",
    revenueMonth: "Ingresos mes",
    proceduresPerMonth: "Procedimientos por mes (últimos 30 días)",
    procedureDistribution: "Distribución de tipos de procedimiento (últimos 30 días)",
    proceduresPerStylist: "Procedimientos por estilista (últimos 30 días)",
    avgAttentionTime: "Tiempo promedio de atención y total de atenciones por estilista (últimos 30 días)",
    avgTime: "Tiempo promedio (minutos)",
    totalAttentions: "Total atenciones",
    clientsAttendedToday: "Clientes atendidos hoy",
    attending: "Atendiendo",
    start: "Inicio",
    end: "Termino",
    finish: "Terminar",
    clientsWaiting: "Clientes en espera",
    arrival: "Llegada",
    attend: "Atender",
    onlyOneClientError:
      "No puedes atender a más de 1 cliente a la vez. Debes marcar el cliente actual como atendido primero.",
    clientAssignedSuccess: "Cliente asignado exitosamente",
    errorLoadingClients: "Error al cargar los clientes",
    procedures: "Procedimientos",
  },
  users: {
    title: "Administración de Estilistas",
    title_mobile: "Estilistas",
    newUser: "Nuevo Estilista",
    editUser: "Editar Estilista",
    createUser: "Crear Estilista",
    name: "Nombre",
    email: "Correo",
    tel: "Telefono",
    // role: "Rol",
    status: "Estatus",
    actions: "Acciones",
    edit: "Editar",
    activeUser: "Estilista activo",
    inactiveUser: "Estilista inactivo",
    save: "Guardar",
    close: "Cerrar",
    fillAllFields: "Por favor, complete todos los campos.",
    updateSuccess: "Usuario actualizado exitosamente.",
    createSuccess: "Usuario creado exitosamente.",
    pinInUse: "El PIN ya está en uso por otro estilista.",
  },
  clients: {
    title: "Catálogo de Clientes",
    title_mobile: "Clientes",
    newClient: "Nuevo Cliente",
    search: "Buscar cliente...",
    edit: "Editar",
    stylist: "Estilista",
    editClient: "Editar Cliente",
    createClient: "Crear Cliente",
    name: "Nombre",
    country: "País de teléfono",
    phone: "Teléfono",
    email: "Correo",
    save: "Guardar",
    close: "Cerrar",
    fillAllFields: "Por favor, complete todos los campos.",
    invalidPhone:
      "Por favor, ingrese un número de teléfono válido de 10 dígitos.",
    updateSuccess: "Cliente actualizado exitosamente.",
    createSuccess: "Cliente creado exitosamente.",
    phoneInUse: "El número de teléfono ya está registrado con otro cliente.",
    headers: {
      name: "Nombre",
      phone: "Teléfono",
      email: "Correo",
      stylist: "Estilista",
      actions: "Acciones",
    },
  },
  services: {
    title: "Catálogo de Servicios",
    title_mobile: "Servicios",
    newService: "Nuevo Servicio",
    search: "Buscar servicio...",
    edit: "Editar",
    active: "Activo",
    inactive: "Inactivo",
    editService: "Editar Servicio",
    createService: "Crear Servicio",
    description: "Descripción",
    serviceActive: "Servicio activo",
    serviceInactive: "Servicio inactivo",
    save: "Guardar",
    close: "Cerrar",
    fillDescription: "Por favor, especifique una descripción.",
    updateSuccess: "Servicio actualizado exitosamente.",
    createSuccess: "Servicio creado exitosamente.",
    headers: {
      description: "Descripción",
      status: "Estatus",
      actions: "Acciones",
    },
  },
  queue: {
    registerArrival: "Registrar llegada de cliente",
    client: "Cliente",
    phone: "Teléfono",
    phonePlaceholder: "Ej. 555-123456",
    selectStylist: "Selecciona un estilista",
    registerButton: "Registrar llegada",
    waitingClients: "Clientes en espera",
    tel: "Tel",
    stylist: "Estilista",
    markAttended: "Marcar como atendido",
    cancelArrival: "Cancelar llegada",
    changeStylist: "Cambiar estilista",
    changeStylistTitle: "Cambiar Estilista",
    stylistChangedSuccess: "Estilista actualizado correctamente.",
    attendingClients: "Clientes en Atención",
    noClientsAttending: "No hay clientes en atención.",
    startTime: "Hora de inicio",
    finishAttention: "Terminar atención",
    attentionFinishedSuccess: "Atención finalizada correctamente.",
    noClientsWaiting: "No hay clientes en espera.",
    createClientTitle: "Crear Cliente",
    name: "Nombre",
    email: "Correo",
    save: "Guardar",
    close: "Cerrar",
    clientAlreadyInQueue: "El cliente ya está en la lista de espera.",
    arrivalRegisteredSuccess: "Llegada registrada exitosamente.",
    fillAllFields: "Por favor llena todos los campos.",
    confirmCancel:
      "¿Estás seguro de que quieres cancelar la llegada de este cliente?",
    arrivalCanceledSuccess: "Llegada cancelada exitosamente.",
    cannotAttendMultiple:
      "No puedes atender a más de 1 cliente a la vez. Debes marcar el cliente actual como atendido primero.",
    clientAssignedSuccess: "Cliente asignado exitosamente.",
    clientAlreadyRegistered: "Cliente ya registrado asignado automáticamente para evitar duplicidad.",
    possibleMatches: "¿Es alguno de estos clientes?",
    clientCreatedSuccess: "Cliente creado exitosamente.",
    clientsAttending: "Este cliente ya está siendo atendido por {stylist}.",
    enterPinTitle: "Ingresar PIN de Estilista",
    pinLabel: "PIN",
    confirm: "Confirmar",
    pinRequired: "El PIN es obligatorio.",
    invalidPin: "PIN incorrecto. Intente de nuevo.",
  },
  attentionList: {
    title: "Listado de Procedimientos",
    title_mobile: "Procedimientos",
    newProcedure: "Nuevo Procedimiento",
    search: "Buscar procedimiento...",
    view: "Ver",
    edit: "Editar",
    photoBefore: "Foto Antes",
    photoAfter: "Foto Después",
    consent: "Consentimiento",
    close: "Cerrar",
    modal: {
      photoBeforeTitle: "Foto antes del procedimiento",
      photoAfterTitle: "Foto después del procedimiento",
      consentTitle: "Carta de Consentimiento",
      consentText:
        "Yo, {clientName}, reconozco que Mily’s Beauty Salon se deslinda de cualquier responsabilidad derivada del procedimiento realizado, aceptando voluntariamente los posibles riesgos y autorizando el tratamiento.",
      clientSignature: "Firma del cliente:",
    },
    headers: {
      client: "Cliente",
      date: "Fecha",
      procedure: "Procedimiento",
      price: "Precio",
      retouch: "Retoque",
      photoBefore: "Foto antes",
      photoAfter: "Foto después",
      consent: "Consentimiento",
      actions: "Acciones",
    },
  },

  attention: {
    title: "Registro de Atención Especializada",
    client: "Cliente",
    datetime: "Fecha y hora",
    service: "Servicio",
    formula: "Procedimiento/Fórmula",
    price: "Precio",
    retouchDate: "Fecha estimada de retoque",
    photoBefore: "Foto antes",
    photoAfter: "Foto después",
    return: "Regresar",
    saveProcedure: "Guardar Procedimiento",
    historyTitle: "Historial de procedimientos",
    noHistory: "No hay historial para este cliente.",
    edit: "Editar",
    consent: {
      title: "Consentimiento Informado",
      text: "Yo, <strong>{clientName}</strong>, reconozco que Mily’s Beauty Salon se deslinda de cualquier responsabilidad derivada del procedimiento realizado, aceptando voluntariamente los posibles riesgos y autorizando el tratamiento.",
      clientSignature: "Firma del cliente:",
      clearSignature: "Limpiar firma",
      viewSignature: "Ver firma",
      viewSavedSignature: "Ver firma de consentimiento",
    },
    modal: {
      capturedSignature: "Firma capturada",
      photoBeforeTitle: "Foto antes del procedimiento",
      photoAfterTitle: "Foto después del procedimiento",
      close: "Cerrar",
    },
    alerts: {
      selectClient: "Por favor, selecciona un cliente.",
      selectDatetime: "Por favor, selecciona una fecha y hora.",
      selectService: "Por favor, selecciona un servicio.",
      enterFormula: "Por favor, ingresa el procedimiento/fórmula.",
      enterPrice: "Por favor, ingresa un precio válido.",
      selectRetouchDate: "Por favor, selecciona una fecha estimada de retoque.",
      selectPhotoBefore:
        "Por favor, selecciona una foto antes del procedimiento.",
      selectPhotoAfter:
        "Por favor, selecciona una foto después del procedimiento.",
      signConsent: "Por favor, firma el consentimiento antes de guardar.",
      createSuccess: "Procedimiento registrado exitosamente.",
      updateSuccess: "Procedimiento terminado exitosamente.",
      loadError: "No se pudo cargar el procedimiento especificado.",
    },
    headers: {
      date: "Fecha",
      procedure: "Procedimiento",
      price: "Precio",
      consent: "Consentimiento",
      retouch: "Retoque",
      actions: "Acciones",
      service: "Servicio",
    },
  },
  analytics: {
    title: "Análisis de Clientes",
    title_mobile: "Análisis",
    newInvitation: "Nueva Invitación",
    visitFrequency: "Frecuencia de visitas",
    view: "Ver",
    sendMsg: "Enviar MSG",
    viewHistory: "Ver Historial",
    tel: "Tel",
    lastVisit: "Última Visita",
    procedure: "Procedimiento",
    nextVisit: "Próx. Visita",
    lastMsg: "Último Msg",
    sendInvitationTitle: "Enviar invitación",
    client: "Cliente",
    message: "Mensaje",
    send: "Enviar",
    close: "Cerrar",
    invitationsTitle: "Invitaciones",
    id: "ID",
    defaultMessage:
      "Hola {clientName}, te recordamos que tu próximo retoque es el {nextVisitDate}. ¡Te esperamos en Mily's Beauty Salon! 😊",
    alerts: {
      selectClient: "Por favor, selecciona un cliente.",
      emptyMessage: "El mensaje no puede estar vacío.",
      createSuccess: "Invitación creada exitosamente.",
    },
    headers: {
      client: "Cliente",
      phone: "Teléfono",
      lastVisit: "Última Visita",
      lastProcedure: "Último Procedimiento",
      nextVisit: "Siguiente Visita",
      lastMessage: "Último Mensaje",
      invitations: "Invitaciones",
      invite: "Invitar",
    },
    clientHeaders: {
      id: "Id",
      date: "Fecha",
      message: "Mensaje",
    },
  },
  queueHistory: {
    title: "Historial de Fila",
    startDate: "Fecha Inicio",
    endDate: "Fecha Fin",
    stylist: "Estilista",
    client: "Cliente",
    status: "Estatus",
    search: "Buscar",
    headers: {
      date: "Fecha",
      client: "Cliente",
      stylist: "Estilista",
      arrival: "Llegada",
      start: "Inicio",
      end: "Fin",
      status: "Estatus"
    },
    alerts: {
      selectDate: "Por favor selecciona al menos una fecha.",
      loadError: "Error al cargar el historial.",
      noDataToPrint: "No hay datos para imprimir."
    }
  },
  confirm: {
    title: "Confirmar Acción",
    confirmBtn: "Confirmar",
    cancelBtn: "Cancelar",
  },
};
